import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ApiUrls } from "./ApiUrls";
import { Page } from "../model/Page";
import { CallCenterSearchModel } from "../model/CallCenterSearchModel";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CallCenterViewModel } from "../model/CallCenterViewModel";
import { ViewApplicationSearchModel } from "../model/ViewApplicationSearchModel";
import { ViewApplicationDetailModel } from "../model/ViewApplicationDetailModel";
import { CorrigendumUploadModel } from "../model/CorrigendumUploadModel";
import { Observable } from "rxjs";
import { FileResponseModel } from "../model/FileResponseModel";

@Injectable({
  providedIn: "root",
})
export class ViewApplicationService {
  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) {}

  fetchCorrigendumFilterList(page: number, size: number, filterText: string) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<CorrigendumUploadModel>>(
      ApiUrls.corrigendumApplicationSearch + reqParams
    );
  }

  fetchCorrigendumView(applicationId: number) {
    return this.httpClient.get<CorrigendumUploadModel>(
      ApiUrls.viewCorrigendumDetail.replace(
        "{applicationId}",
        applicationId.toString()
      )
    );
  }

  fetchFilterList(page: number, size: number, filterText: string) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<ViewApplicationSearchModel>>(
      ApiUrls.viewApplicationSearch + reqParams
    );
  }

  fetchAgrmntIndxFilterList(page: number, size: number, filterText: string) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<ViewApplicationSearchModel>>(
      ApiUrls.viewApplicationSearchByAppNo + reqParams
    );
  }

  fetchDetailView(applicationId: number) {
    return this.httpClient.get<ViewApplicationDetailModel>(
      ApiUrls.viewApplicationDetail.replace(
        "{applicationId}",
        applicationId.toString()
      )
    );
  }

  fetchPOL(registrationId: number, applicationId: number) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchPOL
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationId}", applicationId.toString())
    );
  }

  fetchNOC(registrationId: number, applicationNo: string) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchNOC
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationNo}", applicationNo)
    );
  }

  fetchAllotmentLetter(registrationId: number, applicationNo: string) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchAllotment
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationNo}", applicationNo)
    );
  }

  fetchPossessionLetter(registrationId: number, applicationNo: string) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchPossession
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationNo}", applicationNo)
    );
  }

  fetchIneligibleLetter(registrationId: number, applicationNo: string) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchIneligible
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationNo}", applicationNo)
    );
  }

  fetchESign(registrationId: number, applicationId: number) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchESign
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationId}", applicationId.toString())
    );
  }

  fetchPossessionReceipt(registrationId: number, applicationId: number) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchPossessionReceiptUrl
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationId}", applicationId.toString())
    );
  }

  fetchPossessionAffidavit(registrationId: number, applicationId: number) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchPossessionAffidavitUrl
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationId}", applicationId.toString())
    );
  }

  fetchApplicationsESign(registrationId: number, applicationId: number) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchApplicationsESign
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationId}", applicationId.toString())
    );
  }


  fetchAcknowledgement(registrationId: number, applicationId: number) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchAcknowledgement
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationId}", applicationId.toString())
    );
  }

  fetchEmdReceipt(registrationId: number, applicationId: number) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchEmdReceipt
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationId}", applicationId.toString())
    );
  }

  fetchLOI(registrationId: number, applicationNo: string) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchLOI
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationNo}", applicationNo)
    );
  }

  fetchAcceptance(registrationId: number, applicationNo: string) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchAcceptanceLetter
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationNo}", applicationNo)
    );
  }


  fetchCastValidity(registrationId: number, applicationId: number) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchfetchCastValiditys
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationId}", applicationId.toString())
    );
  }

  fetchAgreementUnSignedCopy(registrationId: number, applicationNo: string) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchAgreementUnSignedCopyLetter
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationNo}", applicationNo)
    );
  }

  fetchAgreementCopy(registrationId: number, applicationNo: string) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchAgreementCopyLetter
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationNo}", applicationNo)
    );
  }

  fetchIndex2(registrationId: number, applicationNo: string) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchIndex2Letter
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationNo}", applicationNo)
    );
  }

  fetchDraftAllotmentLetter(registrationId: number, applicationNo: string) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchDraftAllotmentLetters
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationNo}", applicationNo)
    );
  }

  fetchMarriageCertificate(registrationId: number, applicationId: any) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchMarriageCertificateUrl
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationId}", applicationId)
    );
  }

  // fetchUploadedCorrespondenceLetterService(registrationId: number, applicationId: any) {
  //   return this.httpClient.get<{
  //     status: string;
  //     data: string;
  //     errorMessage: string;
  //   }>(
  //     ApiUrls.fetchUploadedCorrespondenceLetterUrl
  //       .replace("{registrationId}", registrationId.toString())
  //       .replace("{applicationId}", applicationId)
  //   );
  // }

  fetchotherAffidaviteDoc(registrationId: number, applicationId: any) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchotherAffidaviteDocUrl
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationId}", applicationId)
    );
  }

  fetchNameChangeGazette(registrationId: number, applicationId: any) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchNameChangeGazetteUrl
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationId}", applicationId)
    );
  }

  fetchOfficialCasteValidity(registrationId: number, applicationId: any) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchOfficialCasteValidityUrl
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationId}", applicationId)
    );
  }


  appealUploadedDocumentService(registrationId: number, applicationId: any) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.appealUploadedDocumentUrl
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationId}", applicationId)
    );
  }

  downloadKeyHandOverPhotoService(registrationId: number, applicationId: any) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.downloadKeyHandOverPhotoServiceUrl
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationId}", applicationId)
    );
  }


  fetchCaseDatas(registrationId: number, applicationId: number) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchCaseDatass
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationId}", applicationId.toString())
    );
  }


  fetchSurrender(registrationId: number, applicationNo: string) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchSurrenderLetter
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationNo}", applicationNo)
    );
  }


  async successToast(msg) {
    await this._snackBar.open(msg, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }

  generateAgreementLtr(applicationNo: string) {
    console.log("generete agreement letter **** " + applicationNo);
    return this.httpClient.get<FileResponseModel>(
      ApiUrls.generateAgrmntLtr.replace("{applicationNo}", applicationNo)
    );
  }

  uploadAgrmntNIndxLtr(uploadedFile: string | ArrayBuffer, uploadedFileType: string, applicationNo: string){

    console.log("uploaded file content from service", uploadedFile);
    console.log("uploaded file type content from service", uploadedFileType);
    console.log("applicationNo content from service", applicationNo);

    return this.httpClient.post<{status: string, errorMessage: string, sucessMessage: string}>(
      ApiUrls.uploadAgrmntNIndxLtr
      .replace('{uploadedFileType}', uploadedFileType.toString())
      .replace('{applicationNo}', applicationNo.toString()), {
        bas64Data: uploadedFile
    });
  }
  fetchAffidavit(registrationId: number, applicationId: number) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchAffidavit
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationId}", applicationId.toString())
    );
  }
  fetchPossessionsreceipt(registrationId: number, applicationId: number) {
    return this.httpClient.get<{
      status: string; 
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchPossessionsreceipt
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationId}", applicationId.toString())
    );
  }

  fetchKeyhandoverphoto(registrationId: number, applicationId: number) {
    return this.httpClient.get<{
      status: string; 
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchKeyhandoverphoto
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationId}", applicationId.toString())
    );
  }

  generetePossessionReceipt(applicationNo: string) {
    console.log("generete Possession Receipt **** " + applicationNo);
    return this.httpClient.get<FileResponseModel>(
      ApiUrls.generetePossessionReceipt.replace("{applicationNo}", applicationNo)
    );
  }

  fetchPossessionReceiptFormat(registrationId: number, applicationNo: string) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchPossessionReceiptFormat
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationNo}", applicationNo)
    );
  }

  fetchSurrReqFile(registrationId: number, applicationNo: string, reqLtrFile: string) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.fetchSurrReqFile
        .replace("{registrationId}", registrationId.toString())
        .replace("{applicationNo}", applicationNo)
        .replace("{reqLtrFile}", reqLtrFile)
    );
  }
}
